import { Component, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { NgClass } from '@angular/common';
import { SettingsService } from '../../../../../configuration/settings.service';

@Component({
  selector: 'app-whats-new',
  imports: [MatButton, NgClass],
  templateUrl: './whats-new.component.html',
  styleUrl: './whats-new.component.scss',
  standalone: true,
})
export class WhatsNewComponent implements OnInit {
  hideWhatsNewBlock = false;
  currentStep = 0;

  constructor(private settingsService: SettingsService) {}

  ngOnInit() {
    const seenVersion = +this.settingsService.getStringValue(SettingsService.WHATS_NEW_SEEN_VERSION);
    if (seenVersion >= 3.0) {
      this.hideWhatsNewBlock = true;
    }
  }

  skip() {
    this.hideWhatsNewBlock = true;
    this.settingsService.setStringValue(SettingsService.WHATS_NEW_SEEN_VERSION, '3.0');
  }

  next(step: number) {
    this.currentStep = step;
    if (this.currentStep > 6) {
      this.skip();
    }
  }
}
